import { render, staticRenderFns } from "./CatalogsFilter.vue?vue&type=template&id=3cd888e1&"
import script from "./CatalogsFilter.vue?vue&type=script&lang=js&"
export * from "./CatalogsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtnDropdown,QBadge,QIcon,QCard,QItem,QItemSection,QBtn,QCheckbox,QCardActions,QInput,ClosePopup} from 'quasar'
component.options.components = Object.assign({QBtnDropdown,QBadge,QIcon,QCard,QItem,QItemSection,QBtn,QCheckbox,QCardActions,QInput}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
